module.exports = __webpack_public_path__ + "static/media/without-a-song.b20f4eb4.mp3";